/* Stacked campaigns: write --zv-cover (0 → 1) as the next section covers each panel */
(() => {
  if (window.__zvStack) return;
  window.__zvStack = true;
  let panels = [];
  let raf = null;

  const collect = () => {
    panels = Array.from(document.querySelectorAll('.zv-camp--stack')).map((el) => {
      const wrapper = el.closest('.shopify-section') || el;
      return { el, next: wrapper.nextElementSibling };
    });
  };

  const update = () => {
    raf = null;
    const vh = window.innerHeight || 1;
    panels.forEach(({ el, next }) => {
      if (!next) return;
      const top = next.getBoundingClientRect().top;
      const cover = Math.min(1, Math.max(0, 1 - top / vh));
      el.style.setProperty('--zv-cover', cover.toFixed(3));
    });
  };

  const onScroll = () => {
    if (raf === null) raf = requestAnimationFrame(update);
  };

  const start = () => {
    collect();
    update();
    // capture: catches scrolling on the theme's own scroll container as well as the window
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', () => { collect(); update(); });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-zv-video-toggle]');
    if (!btn) return;
    const videos = btn.closest('.zv-camp')?.querySelectorAll('video');
    if (!videos || !videos.length) return;
    const pause = !videos[0].paused;
    videos.forEach((v) => { if (pause) v.pause(); else v.play(); });
    btn.setAttribute('aria-pressed', String(pause));
    btn.setAttribute('aria-label', pause ? btn.dataset.labelPlay : btn.dataset.labelPause);
  });
})();
